const getUnfinishedStepsCount = (siteProgressChecklist) =>
  Object.values(siteProgressChecklist).filter((value) => !value).length;

export default getUnfinishedStepsCount;
